export * as CommonText from './common-text';
export * as Dictionary from './Dictionary';
export * as FileSystem from './FileSystem';
export * as Timer from './timer';
export * as Icon from './Icon';
export * as Json from './Json';
export { default as locale, Locale, setupLocale, measurementSystems as localeMeasurementSystems } from './Locale';
export { default as Logger } from './Logger';
export * as Math from './Math';
export * as Restrictions from './Restrictions';
export * as Uuid from './Uuid';
export * as Chemistry from './Chemistry';
export * as Object from './Object';
export * from './throttle';
export * from "./Error";
export * from "./codecs";

/**
 * Tests if the variable has a meaningful value.
 * Test fails for:
 * - undefined
 * - null
 * - empty string
 * 
 * Test passes for:
 * - string with length > 0
 * - 0
 * - true/false
 * - ...
 * @param value Value to test.
 * @returns 
 */
export function isSet(value: any): boolean {
    if (typeof value === "undefined") return false;
    if (value === null) return false;
    if (value === "") return false;
    return true;
}
